import { nonEmptyTrimmedStringFromUnknown } from "../protocol/shared.js";
import { dispatchResultSchema } from "../space-mesh/dispatch-result.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-result.ts
const optionalSelectorSchema = z$1.preprocess((value) => {
	const normalized = String(value ?? "").trim();
	return normalized.length > 0 ? normalized : void 0;
}, z$1.string().min(1).optional());
const getSpaceDispatchResultInputSchema = z$1.strictObject({
	spaceId: nonEmptyTrimmedStringFromUnknown,
	dispatchId: optionalSelectorSchema,
	resultRef: optionalSelectorSchema
}).superRefine((value, ctx) => {
	if (Number(typeof value.dispatchId === "string") + Number(typeof value.resultRef === "string") !== 1) ctx.addIssue({
		code: "custom",
		message: "exactly one of dispatchId or resultRef is required",
		path: ["dispatchId"]
	});
});
const getSpaceDispatchResultResponseSchema = dispatchResultSchema;
//#endregion
export { getSpaceDispatchResultInputSchema, getSpaceDispatchResultResponseSchema };

//# sourceMappingURL=space-result.js.map